/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Max_Attempts_ReachedInputs */

const en_course_max_attempts_reached = /** @type {(inputs: Course_Max_Attempts_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum attempts reached`)
};

const ja_course_max_attempts_reached = /** @type {(inputs: Course_Max_Attempts_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大試行回数に達しました`)
};

const fr_course_max_attempts_reached = /** @type {(inputs: Course_Max_Attempts_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre maximal de tentatives atteint`)
};

const de_course_max_attempts_reached = /** @type {(inputs: Course_Max_Attempts_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Anzahl an Versuchen erreicht`)
};

/**
* | output |
* | --- |
* | "Maximum attempts reached" |
*
* @param {Course_Max_Attempts_ReachedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_max_attempts_reached = /** @type {((inputs?: Course_Max_Attempts_ReachedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Max_Attempts_ReachedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_max_attempts_reached(inputs)
	if (locale === "ja") return ja_course_max_attempts_reached(inputs)
	if (locale === "fr") return fr_course_max_attempts_reached(inputs)
	return de_course_max_attempts_reached(inputs)
});